import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import MenuSalades from './pages/MenuSalades';
import MenuPates from './pages/MenuPates';
import OuNousTrouver from './pages/OuNousTrouver';
import Allergenes from './pages/Allergenes';
import Recrutement from './pages/Recrutement';
import Contact from './pages/Contact';
import MentionsLegales from './pages/MentionsLegales';
import Admin from './pages/Admin';

function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/menus-salades" element={<Layout><MenuSalades /></Layout>} />
        <Route path="/menus-pates" element={<Layout><MenuPates /></Layout>} />
        <Route path="/ou-nous-trouver" element={<Layout><OuNousTrouver /></Layout>} />
        <Route path="/allergenes" element={<Layout><Allergenes /></Layout>} />
        <Route path="/recrutement" element={<Layout><Recrutement /></Layout>} />
        <Route path="/contact" element={<Layout><Contact /></Layout>} />
        <Route path="/mentions-legales" element={<Layout><MentionsLegales /></Layout>} />
        {/* Admin — URL secrète, sans Navbar/Footer */}
        <Route path="/admin-grainette" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
